// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"765":"f0622bad","2589":"32fc1245","4983":"8d6c87f1","7628":"68fb284d"}[chunkId] + ".css";
};